export const CHATGPT_SUBSCRIPTION_BLOCKED_MESSAGE =
  'Tu suscripción actual no incluye Asistentes IA ni Reportes. Para habilitar estas funcionalidades y dar el siguiente salto con Aluxia, contactate con el administrador de Aluxia.';

export const CALENDARIO_SUBSCRIPTION_BLOCKED_MESSAGE =
  'Tu suscripción actual no incluye Calendario. Para habilitar esta funcionalidad y dar el siguiente salto con Aluxia, contactate con el administrador de Aluxia.';

const readFirstValue = (source, keys) => {
  if (!source) return undefined;
  return keys.map((key) => source[key]).find((value) => value !== undefined && value !== null);
};

export const toBooleanPermission = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'si' || normalized === 'sí';
  }
  return false;
};

export const isParticularChatGPTAllowed = (particular) => (
  toBooleanPermission(readFirstValue(particular, [
    'permiteChatGPT',
    'PermiteChatGPT',
    'permiteChatGpt',
    'PermiteChatGpt'
  ]))
);

export const isParticularCalendarioAllowed = (particular) => (
  toBooleanPermission(readFirstValue(particular, [
    'calendario',
    'Calendario'
  ]))
);

export const isParticularChatGPTMenuItem = (item) => (
  Boolean(item?.requiresChatGPTAccess) || item?.id === 'asistentes' || item?.id === 'reportes'
);

export const isParticularCalendarioMenuItem = (item) => (
  Boolean(item?.requiresCalendarAccess) || item?.id === 'calendario'
);
